import { advancePayConstants } from '../constants';

import { promiseInstance_authorization } from './config';

import { func_serviceHandling, func_validation } from 'functions';
import { Toaster } from 'components/notification/Toaster';



export const advancePayActions = {
	getAdvancePaySetupList,
	getAllAdvancePaySetupList,
    
	addAccount,
	updateAccount,
    generateInvoice,
    generateDebitNote,
    deleteAccount
};

function getAdvancePaySetupList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;
		
		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/BillingSetup/SearchAdvancePaySetup', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.getAdvancePaySetupList_request, details }; }
    function success(details) { return { type: advancePayConstants.getAdvancePaySetupList_success, details }; }
    function failure(error) { return { type: advancePayConstants.getAdvancePaySetupList_failure, error }; }
}

function getAllAdvancePaySetupList(pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());
        
		let paramObj = {
			limit: 0,
			sort: sort,
			...filterOptions
		}

		let url = func_serviceHandling.createUrlWithParams('/BillingSetup/SearchAdvancePaySetup', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.getAllAdvancePaySetupList_request, details }; }
    function success(details) { return { type: advancePayConstants.getAllAdvancePaySetupList_success, details }; }
    function failure(error) { return { type: advancePayConstants.getAllAdvancePaySetupList_failure, error }; }
}

function addAccount(accountInfo) {
    return dispatch => {
		dispatch(request());

		let accountInfo_validated = "";
		if (func_validation.isObjectNotEmpty(accountInfo))
			accountInfo_validated = accountInfo;

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup/InsertOrUpdateAdvancePay', JSON.stringify(accountInfo_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully added account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.addAccount_request, details }; }
    function success(details) { return { type: advancePayConstants.addAccount_success, details }; }
    function failure(error) { return { type: advancePayConstants.addAccount_failure, error }; }
}

function updateAccount(accountInfo) {
    return dispatch => {
		dispatch(request());

		let accountInfo_validated = "";
		if (func_validation.isObjectNotEmpty(accountInfo))
			accountInfo_validated = accountInfo;

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/BillingSetup/InsertOrUpdateAdvancePay', JSON.stringify(accountInfo_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully updated account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.updateAccount_request, details }; }
    function success(details) { return { type: advancePayConstants.updateAccount_success, details }; }
    function failure(error) { return { type: advancePayConstants.updateAccount_failure, error }; }
}

function generateInvoice(accountDetails) {
    return dispatch => {
		dispatch(request());

		let url = func_serviceHandling.createUrlWithParams('/Invoice/GenerateAdvancePayInvoice', accountDetails);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully generated invoice"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate invoice";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.generateInvoice_request, details }; }
    function success(details) { return { type: advancePayConstants.generateInvoice_success, details }; }
    function failure(error) { return { type: advancePayConstants.generateInvoice_failure, error }; }
}

function generateDebitNote(accountDetails) {
    return dispatch => {
		dispatch(request());
		
		let url = func_serviceHandling.createUrlWithParams('/Invoice/GenerateDebitNote', accountDetails);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully generated debit note"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate debit note";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.generateDebitNote_request, details }; }
    function success(details) { return { type: advancePayConstants.generateDebitNote_success, details }; }
    function failure(error) { return { type: advancePayConstants.generateDebitNote_failure, error }; }
}

function deleteAccount(accountId) {
    return dispatch => {
		dispatch(request());
		
		let accountId_formatted = "";
		if (func_validation.isNumberValid(accountId)) accountId_formatted = encodeURI(accountId);

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/BillingSetup/DeleteAdvancePaySetup/' + accountId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted account"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete account";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: advancePayConstants.deleteAccount_request, details }; }
    function success(details) { return { type: advancePayConstants.deleteAccount_success, details }; }
    function failure(error) { return { type: advancePayConstants.deleteAccount_failure, error }; }
}